import { POST } from 'utils/requests.utils'

const BASE_URL = '/common/tracking_logs'

export const createItem = (data) => POST(BASE_URL, data)
